"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return getColumnUiType;
    }
});
const _ModelXcMetaFactory = /*#__PURE__*/ _interop_require_default(require("~/db/sql-mgr/code/models/xc/ModelXcMetaFactory"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function getColumnUiType(source, column) {
    const metaFact = _ModelXcMetaFactory.default.create({
        client: source.type
    }, {});
    return metaFact.getUIDataType(column);
}
